import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import {
  getMagnetId,
  getUserInfo,
  getVisitId,
  post,
  setUserInfo,
} from './eventUtils';

// Copy and pasted from tour magnet api.js with slight changes

// Used to keep track of metadata required for Events
// Having this global thing here is pretty bad, but the alternative
// is passing a lot of parameters around just for analytics or a Context
export let analyticsMetadata = {
  route: null,
  videoTime: null,
};

// This should be kept in sync with EventType in models.py on the backend
const EVENT_TYPE = Object.freeze({
  OPEN_TOUR: 'open_tour',
  BUTTON_CLICK: 'button_click',
  FORM_SUBMISSION: 'form_submission',
  CLOSE_TOUR: 'close_tour',
});

// Map EVENT_TYPEs to Google Analytics events
const GA_EVENT = Object.freeze({
  open_tour: 'Open Tour',
  button_click: 'Button Click',
  form_submission: 'Form Submission',
  close_tour: 'Close Tour',
});

const ga_event_label = (type, details) => {
  if (type === EVENT_TYPE.BUTTON_CLICK) {
    return details.to;
  } else if (type === EVENT_TYPE.FORM_SUBMISSION) {
    return details.form_route;
  } else if (type === EVENT_TYPE.CLOSE_TOUR) {
    return details.last_route;
  }
  return undefined;
};

// Map EVENT_TYPEs to Facebook Pixel events
const PIXEL_EVENT = Object.freeze({
  open_tour: 'OpenTour',
  button_click: 'ButtonClick',
  form_submission: 'FormSubmission',
  close_tour: 'CloseTour',
});

const track = async (type, details) => {
  // Add current lead UUID to `details`
  const { leadUUID } = getUserInfo();
  if (leadUUID) details.lead_uuid = leadUUID;

  // It's OK to fire GA or Pixel events even if it isn't initialized
  ReactGA.event({
    category: 'Tour Event',
    action: GA_EVENT[type],
    label: ga_event_label(type, details),
    ...('video_time' in details && { value: details.video_time }),
  });
  ReactPixel.trackCustom(PIXEL_EVENT[type], details);

  const res = await post('/event', {
    visit_uuid: await getVisitId(),
    magnet_uuid: getMagnetId(),
    url: window.location.href,
    event_type: type,
    details: details,
  });
  return res;
};

export const startVisit = async (magnetTemplate) => {
  if ('gaPropertyId' in magnetTemplate) {
    // Note that react-ga only supports "UA-" (Universal Analytics) IDs,
    // not "G-" (Google Analytics 4) IDs. Google Analytics does have an
    // option to create both a UA and a GA4 ID for the same project though
    ReactGA.initialize(magnetTemplate.gaPropertyId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
        // userId?
      },
    });
    // We could use custom URLs here to track movement through the screens
    // instead of using ButtonClick events
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  if ('fbPixelId' in magnetTemplate) {
    ReactPixel.init(magnetTemplate.fbPixelId, {
      autoConfig: true,
      debug: false,
    });
    ReactPixel.pageView();
  }
  // getVisitId() will fetch a new visit UUID if one isn't found in cookies
  await getVisitId();
};

export const startTour = (name = null) => {
  track(EVENT_TYPE.OPEN_TOUR, { type: 'tour_page', name: name });
};

export const buttonClick = (from, to) => {
  const res = track(EVENT_TYPE.BUTTON_CLICK, {
    // Please note based on how the backend, analytics dashboard, etc is set up we only
    // look at the from, to fix this issue tempurarly we just switched from and to
    // note that this is not a permanent solution but allows analytics to work correctly
    // TODO: update this when backend and frontend are update to allow for better use of
    // to and fron
    from: to,
    to: from,
    video_time: analyticsMetadata.videoTime,
  });
  return res;
};

export const formSubmission = async (formData) => {
  const res = await track(EVENT_TYPE.FORM_SUBMISSION, {
    form_data: formData,
    form_route: window.location.href,
    video_time: analyticsMetadata.videoTime,
  });
  const newLeadUUID = res.lead_uuid;
  if (newLeadUUID) {
    setUserInfo({
      leadUUID: newLeadUUID,
      // Some of these may be undefined, that's OK
      name: formData.lead_name,
      email: formData.lead_email,
      phone: formData.lead_phone,
    });
  }
  return res;
};
